/**
 * API keys
 */
export const API_HOST_TOKEN = process.env.REACT_APP_API_HOST_TOKEN

/**
 * Environment
 */
export const API_HOST = process.env.REACT_APP_API_HOST

/**
 * MQTT
 */
export const MQTT_HOST = process.env.REACT_APP_MQTT_HOST
export const MQTT_PORT = process.env.REACT_APP_MQTT_PORT
export const MQTT_PROTOCOL = process.env.REACT_APP_MQTT_PROTOCOL
export const MQTT_USER = process.env.REACT_APP_MQTT_USER
export const MQTT_PASSWORD = process.env.REACT_APP_MQTT_PASSWORD
export const MQTT_TOPIC = process.env.REACT_APP_MQTT_TOPIC
export const MQTT_COMMAND = {
  PLAY: 'play',
  PAUSE: 'pause',
  SHOW_CONTENT: 'showContent',
  REFRESH: 'refreshContent',
}

/**
 * Settings
 */
export const INACTIVITY_TIME = 1 * 60 * 1000 // 1 minute
export const VIDEO_INACTIVITY_DELAY = 4 * 1000 // 4 seconds
export const DEFAULT_CONTENT_TIME = 5 * 1000 // 10 seconds
export const DEFAULT_TRANSITION_TIME = 750 // 750 milliseconds
export const BROWSER_AUTORELOAD = 14400000 // 4 hours
